import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoEyeSharp } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa';
import "./Login.css";

const Login = () => {
  const [userlogin, setUserLogin] = useState({
    contactNo: "",
    password: "",
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const backPath = localStorage.getItem("backPaath")

  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const API_BASE_URL = process.env.REACT_APP_API_KEY;
  const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

  let outletId, outletlogo, outletName;

  if (Array.isArray(storedData) && storedData.length > 0) {
    outletId = storedData[0].outletId;
    outletlogo = storedData[0].outletlogo;
    outletName = storedData[0].outletName;
  } else if (storedData && typeof storedData === "object") {
    outletId = storedData.outletId;
    outletlogo = storedData.outletlogo;
    outletName = storedData.outletName;
  }

  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserLogin((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Login Submit
  const LoginSubmit = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}CustomerMaster/login`, userlogin);

      if (response.status === 200) {
        console.log("Login Successfully");

        // Extract customer details
        const loginDetails = {
          customerId: response.data.customerId,
          preferredAddress: response.data.preferredAddress,
          customerName: response.data.customerName
        };

        // Save to local storage
        localStorage.setItem("loginDetails", JSON.stringify(loginDetails));

        // Redirect to home page
        navigate(backPath);
      }
    } catch (error) {
      console.error("Login Error:", error.response?.data || error.message);
      alert("Invalid login credentials. Please try again.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="col-md-12">
        {/* Navbar */}
        <nav className="navbar navbar-light bg-light shadow-sm bg-body rounded">
          <div className="container-fluid">
            <a className="navbar-brand" href="#">
              <img
                src={outletlogo}
                alt="Outlet Logo"
                width={60}
                height={40}
                className="d-inline-block align-text-center me-2 img-fluid"
              />
              <strong>{outletName}</strong>
            </a>
          </div>
        </nav>

        {/* Login Form */}
        <h1 className="mt-5 text-center">Log-In</h1>
        <div className="row d-flex justify-content-center">
          <div className="col-10 mt-4 border p-5 shadow p-3 mb-5 bg-body rounded">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Mobile No"
                name="contactNo"
                value={userlogin.contactNo}
                onChange={handleInputChange}
              />
            </div>

            <div className="mb-3 p-0 position-relative">
  <input
    type={showPassword ? "text" : "password"}
    className="form-control"
    placeholder="Enter Password"
    name="password"
    value={userlogin.password}
    onChange={handleInputChange}
  />
  <span
    className="position-absolute end-0 translate-middle-y me-3"
    style={{ cursor: "pointer", marginTop: "-18px" }}
    onClick={togglePassword}
  >
    {showPassword ? <IoEyeSharp size={23} /> :  <FaEyeSlash size={23} /> }
  </span>
  <p style={{ fontSize: "15px" }}>Last five digits of Mobile Number</p>
</div>

            {/* Login Buttons */}
            <div className="d-flex justify-content-between mt-5">
              <button className="btn btn-primary loginBtnCss" onClick={LoginSubmit}>
                Log-In
              </button>
              <h4 className="mt-2">OR</h4>
              <Link to="/RegCustomer" className="btn btn-danger loginBtnCss">
                Sign-Up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
